import { QRCodeState } from "./qr-codes.interface";

export const initialQRCodeState: QRCodeState = {
    qrCodes: []
}